import { onBeforeUnmount, onMounted } from "vue";
import { IS_APPLE } from "@/shared/utils/modifierKeys";
import { handlePageSearchKey } from "@/shared/utils/pageSearch";

/**
 * ⌘F / Ctrl+F to the page's own search field — see `shared/utils/pageSearch`.
 *
 * Installed once, in App.vue, rather than per view: which field is the page's is a question
 * about what is on screen right now, dialogs included, and only the whole document can answer
 * it. On `window`, in the bubble phase, so any handler closer to the event — Monaco's own
 * find, a dialog's — has had its turn and can claim it with `preventDefault`.
 */
export function usePageSearchShortcut(): void {
	function onKeydown(event: KeyboardEvent) {
		handlePageSearchKey(event, { apple: IS_APPLE, doc: document });
	}
	onMounted(() => window.addEventListener("keydown", onKeydown));
	onBeforeUnmount(() => window.removeEventListener("keydown", onKeydown));
}
